import { Model } from 'pinia-orm';
import Company from './Company';
import EmailSignature from './EmailSignature';
import Role from './Role';
import User from './User';


export default class CompanyUser extends Model {

    static get entity () {
        return 'company_users'
    }

    static get primaryKey () {
        return ['company_id', 'user_id'];
    }

    static fields () {
        return {
            id: this.uid(),
            company_id: this.attr(null),
            user_id: this.attr(null),
            role_id: this.attr(null),
            is_owner: this.boolean(false),
            settings: this.attr({}),
            phone: this.attr(null),
            position: this.attr({}),
            default_email_signature_id: this.attr(null),

            //relationships
            company: this.belongsTo(Company, 'company_id'),
            role: this.belongsTo(Role, 'role_id'),
            user: this.belongsTo(User, 'user_id'),
            defaultEmailSignature: this.belongsTo(EmailSignature, 'default_email_signature_id'),
        }
    }
}
